<div class='container'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Search production logs</div>

        <div class="row">
            <div class="alert alert-warning text-center fs-5 col-md-5" role="alert" data-mdb-color="warning">
                <b>Physio IOS</b> sync <br><br> {{this.applicationProductMap.get(applications.PHYSIO + products.IOS)}}
            </div>
            <div class="alert alert-warning text-center fs-5 col-md-5" role="alert" data-mdb-color="warning">
                <b>Physio ANDROID</b> sync <br><br> {{this.applicationProductMap.get(applications.PHYSIO + products.ANDROID)}}
            </div>
        </div>

        <div class='flex-grow-1 fs-2 lh-base text-center mt-5 mb-5'> <b>Search with serial code</b></div>
        <div class="flex-grow-1 fs-6 lh-base" style="margin-top: 24px;margin-bottom: 24px;">
            Append a single serial code and select a date range ( <b>Default is 2 months</b> ).<br>
        </div>
        <div class="d-flex flex-row align-items-center">
            <app-text-search class="flex-grow-1"
                             [value]='searchValueSerialCode'
                             [searchHint]='searchHintSerialCode'
                             [minLength]='minLength'
                             (submitEvent)='onSubmitSerialCodeSearch()'
                             (valueChange)='onSerialCodeValueChanged($event)'
            >
            </app-text-search>
            <div mat-line class="detail">
                <div class='h6' style="text-align: center">From</div>
                <mat-form-field appearance="fill" class="picker" style="margin-left: 20px;margin-right: 20px;">
                        <mat-label>(mm/dd/yyyy)</mat-label>
                        <input matInput
                               [matDatepicker]="fromPickerSerialCode"
                               [(ngModel)]="fromDateSerialCodeSearch"
                               (dateChange)="onFromDateSerialCodeSearchChanged($event)">
                        <mat-datepicker-toggle matSuffix [for]="fromPickerSerialCode"></mat-datepicker-toggle>
                        <mat-datepicker #fromPickerSerialCode></mat-datepicker>
                </mat-form-field>
            </div>
            <div mat-line class="detail">
                <div class='h6' style="text-align: center">To</div>
                <div>
                    <mat-form-field appearance="fill" class="picker" style="margin-left: 20px;margin-right: 20px;">
                        <mat-label>(mm/dd/yyyy)</mat-label>
                        <input matInput
                               [matDatepicker]="toPickerSerialCode"
                               [(ngModel)]="toDateSerialCodeSearch"
                               (dateChange)="onToDateSerialCodeSearchChanged($event)">
                        <mat-datepicker-toggle matSuffix [for]="toPickerSerialCode"></mat-datepicker-toggle>
                        <mat-datepicker #toPickerSerialCode></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <button class="m-3" color="primary" mat-raised-button type='submit'
                    [disabled]='!canSearchSerialCode()'
                    (click)="onSubmitSerialCodeSearch()">Search
            </button>
        </div>
    </div>
    <div class='flex-grow-1 fs-2 lh-base text-center mt-5 mb-5'> <b>Search with account's email</b></div>
    <div class="flex-grow-1 fs-6 lh-base" style="margin-top: 24px;margin-bottom: 24px;">
        Append an email and select a date range ( <b>Default is 3 days</b> ).<br>
        Because this is a slow and heavy procedure please keep the time range to a maximum of <b>15 days.</b><br>
    </div>
    <div class="d-flex flex-row align-items-center">
        <app-text-search class="flex-grow-1"
                         [value]='searchValueAccountEmail'
                         [searchHint]='searchHintAccountEmail'
                         [minLength]='minLength'
                         (submitEvent)='onSubmitAccountEmailSearch()'
                         (valueChange)='onAccountEmailValueChanged($event)'
        >
        </app-text-search>
        <div mat-line class="detail">
            <div class='h6' style="text-align: center">From</div>
            <mat-form-field appearance="fill" class="picker" style="margin-left: 20px;margin-right: 20px;">
                <mat-label>(mm/dd/yyyy)</mat-label>
                <input matInput
                       [matDatepicker]="pickerAccountEmail"
                       [(ngModel)]="fromDateAccountEmailSearch"
                       (dateChange)="onFromDateAccountEmailSearchChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="pickerAccountEmail"></mat-datepicker-toggle>
                <mat-datepicker #pickerAccountEmail></mat-datepicker>
            </mat-form-field>
        </div>
        <div mat-line class="detail">
            <div class='h6' style="text-align: center">To</div>
            <div>
                <mat-form-field appearance="fill" class="picker" style="margin-left: 20px;margin-right: 20px;">
                    <mat-label>(mm/dd/yyyy)</mat-label>
                    <input matInput
                           [matDatepicker]="toPickerAccountEmail"
                           [(ngModel)]="toDateAccountEmailSearch"
                           (dateChange)="onToDateAccountEmailSearchChanged($event)">
                    <mat-datepicker-toggle matSuffix [for]="toPickerAccountEmail"></mat-datepicker-toggle>
                    <mat-datepicker #toPickerAccountEmail></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <button class="m-3" color="primary" mat-raised-button type='submit'
                [disabled]='!canSearchAccountEmail()'
                (click)="onSubmitAccountEmailSearch()">Search
        </button>
    </div>

    <div class="d-flex justify-content-center align-items-center align-content-center my-lg-5" *ngIf="this.searchMode === this.searchModes.SUMMARY_DETAILED_MESSAGE">
        <button class="m-3 me-lg-4" color="primary" mat-raised-button type='submit'
                (click)="onBackToSummaryLogs()">Back to Summary logs
        </button>
        <h3 class="flex-grow-1 text-center">You are viewing detailed logs regarding <b>{{this.detailedSummaryTitle}}...</b></h3>
    </div>

    <div class="d-flex flex-column my-lg-5 view-surrounding-logs" *ngIf="this.showViewSurroundingLogs()">
         <h3 class = "fs-5 lh-base mb-md-3 text-center"> Select an email and click on a date to search all logs of an account
             at that specific date. <br>
             This will return logs that <b>may not contain a serial code</b> but will have the word <b><u>Device</u></b> inside them.<br>
             Useful for when searching for <b>Device Error, Device Fatal Error, BleDeviceError</b> etc.</h3>
        <h2><b>View surrounding logs</b> of email </h2>
        <mat-chip-list>
            <mat-chip class="tag fs-6 p-2 mx-md-3" *ngFor="let email of getEmailsSummaryLogs()"
                      [selected]="email === this.emailToViewSurroundingLogs"
                      (click)="this.onEmailToViewSurroundingLogsPressed(email)">
                {{email}}
            </mat-chip>
        </mat-chip-list>
        <h2 class="my-md-3"><b> at date </b></h2>
        <mat-chip-list>
            <mat-chip class="tag fs-6 p-2 mx-md-3" *ngFor="let timestamp of getMostRecentDatesOfSummaryLogs()"
                      (click)="this.onViewSurroundingLogsOfDayClick(timestamp)">
                {{getFormattedDate(timestamp)}}
            </mat-chip>
        </mat-chip-list>
    </div>

    <div class="my-lg-5">
        <div class="d-flex flex-row justify-content-center">
            <mat-chip class="tag fs-6 p-2" [selected]="this.searchMode === searchModes.SUMMARY || this.searchMode === this.searchModes.SUMMARY_DETAILED_MESSAGE" (click)="this.onSearchModeChipSelected(searchModes.SUMMARY)">Summary</mat-chip>
            <mat-chip class="tag fs-6 p-2 mx-md-5" [selected]="this.searchMode === searchModes.DETAILED" (click)="this.onSearchModeChipSelected(searchModes.DETAILED)">Detailed</mat-chip>
        </div>
    </div>

    <app-generic-admin-report-table *ngIf="this.searchMode === searchModes.DETAILED || this.searchMode === this.searchModes.SUMMARY_DETAILED_MESSAGE"
                                    [filter]='filter'
                                    [columnData]='detailedColumns'
                                    [loadingState]='loadingState'
                                    [dataSource]='detailedDataSource'
                                    [truncateColumns]='truncateColumns'
                                    modelLabel='Detailed Logs'
                                    searchLabel='Search Detailed Sensor Production Logs'
                                    (sqCellClick)='onCellClick($event)'>
    </app-generic-admin-report-table>

    <app-generic-admin-report-table *ngIf="this.searchMode === searchModes.SUMMARY"
                                    [filter]='filter'
                                    [columnData]='summaryColumns'
                                    [loadingState]='loadingState'
                                    [dataSource]='summaryDataSource'
                                    modelLabel='Summary Logs'
                                    searchLabel='Search Summary Sensor Production Logs'
                                    (rowClickEvent)="onSummaryRowClicked($event)">

    </app-generic-admin-report-table>
</div>
